import React, { useEffect, useRef , useState } from 'react';
import { Link } from 'react-router-dom';
import leftArrowIcon from '../../../public/assets/images/leftArrowIcon.png';
import filter from '../../../public/assets/images/filter.png';
import expandfilter from '../../../public/assets/images/expandfilter.png';
import Button from '../../components/button/Button';
import Select from '../../components/select';
import filters from '../../../public/assets/images/filters.png';
import search from '../../../public/assets/images/searchIcon.png'
import Textbox from './Textbox';
import Daterange from './Daterange';
import { useDispatch, useSelector } from 'react-redux';
import {designationdetails,
  hierarchyDropdownList,
  STPFCReportDetails,
  STPFCAdminReportDetails,
  clearSfcReportData,
} from '../../redux/slice/sfcReport';
import Loader from '../../components/modal/Loader';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const Sfcreport = () => {
  const [showFilters, setShowFilters] = useState(false);
  const [activeReport, setActiveReport] = useState('SFC');
  const [columnFilters, setColumnFilters] = useState({});
  const [mobileFilter, setMobileFilter] = useState('');

  const [selectedHierarchy, setSelectedHierarchy] = useState(null);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [dateRange, setDateRange] = useState({ from: null, to: null });
  const [isPageLoading, setIsPageLoading] = useState(true);

  const dispatch =useDispatch();
  const {desigdata,hierarchydropdown,sfcdetails,sfcadminreport}=useSelector((state)=>state.sfcReport);

  const area=JSON.parse(localStorage.getItem('userData'))?.areaRange;
  const employeeLevel=area?.includes('T')||'';

  useEffect(() => {
  if (employeeLevel && hierarchydropdown?.length && desigdata?.length) {

    const autoHierarchy = hierarchydropdown[0];
    const autoDesignation = desigdata[0];

    setSelectedHierarchy(autoHierarchy);
    setSelectedDesignation(autoDesignation);
  }
}, [employeeLevel, hierarchydropdown, desigdata]);



  useEffect(()=>{
    dispatch(designationdetails());
    dispatch(hierarchyDropdownList());
  },[dispatch]);

    useEffect(() => {
      return () => {
        dispatch(clearSfcReportData());
      };
    }, [dispatch]);
    useEffect(() => {
      const timer = setTimeout(() => {
        setIsPageLoading(false);
      }, 500);

      return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
      if (selectedHierarchy && dateRange.from && dateRange.to) {
        const loginempId = JSON.parse(
          localStorage.getItem('userData')
        )?.employeeId;
        const Company_Id = JSON.parse(
          localStorage.getItem('userData')
        )?.companyId;
        const { hierarchyId, hierarchyTypeId } = selectedHierarchy;

        const data = {
          loginempId,
          hierarchyId,
          hierarchyTypeId,
          Company_Id,
          fromdate: dateRange.from,
          todate: dateRange.to,
        };

        if (activeReport === 'SFC') {
          dispatch(STPFCReportDetails(data));
        } else if (activeReport === 'SFC_Admin') {
          dispatch(STPFCAdminReportDetails(data));
        }
      }
    }, [
      selectedHierarchy,
      selectedDesignation,
      dateRange,
      activeReport,
      dispatch,
    ]);




  // Different headers for different reports
  const reportHeaders = {
    SFC: [
      'Employee Code',
      'Employee Name',
      'Designation',
      'Division',
      'HQ',
      'From City',
      'To City',
      'Category',
      'Distance (Oneway)',
      'Transit Allownace (₹)',
      'Daily Allownace (₹)',
      'Total Amount (₹)',
      'Effective From Date',
      'Effective To Date',
    ],
    SFC_Admin: [
      'Employee Code',
      'Employee Name',
      'Designation',
      'Division',
      'HQ',
      'From City',
      'To City',
      'Category',
      'Distance (Oneway)',
      'Transit Allownace (₹)',
      'Daily Allownace (₹)',
      'Total Amount (₹)',
      'Effective From Date',
      'Effective To Date',
    ],
  };

  // Example dummy data for now
  const reportData = {

    SFC:sfcdetails?.length ?
    sfcdetails.map((item)=>{
     const [designation, hq] = item.designation
    ? item.designation.split('-')
    : ['-', '-'];
      return[
      item.empCode,
      item.empName,
      designation,
      item.division,
      hq,
      item.fromCity,
      item.toCity,
      item.category,
      `${item.distance} KM` ||0,
      item.ta || '-',
      item.da || '-',
      item.total || 0,
      item.fromDate || '-',
      item.toDate || '-'
      ];
    }):[],
    SFC_Admin:sfcadminreport.length?
    sfcadminreport.map((item)=>{
      const [designation, hq] = item.designation
    ? item.designation.split('-')
    : ['-', '-'];
      return[
      item.empCode,
      item.empName,
      designation,
      item.division,
      hq,
      item.fromCity,
      item.toCity,
      item.category,
      `${item.approvedDistance} KM` ||0,
      item.ta,
      item.da,
      item.total || 0,
      item.fromDate,
      item.toDate
      ];
    }):
    [],
  };

  const headers = reportHeaders[activeReport];
  const rows = reportData[activeReport];


  // Filter rows based on columnFilters
   const filteredRows = Array.isArray(rows)
      ? rows.filter((row) => {
          // Desktop column filters
          const matchesColumnFilters = Object.keys(columnFilters).every((key) => {
            const filterValue = columnFilters[key];
            if (!filterValue) return true;
            const cellValue = row[key]?.toString().toLowerCase() || '';
            return cellValue.includes(filterValue.toLowerCase());
          });

          // Mobile global filter (checks any field)
          const matchesMobileFilter = !mobileFilter
            ? true
            : Object.values(row)
                .join(' ')
                .toLowerCase()
                .includes(mobileFilter.toLowerCase());

          return matchesColumnFilters && matchesMobileFilter;
        })
      : [];

    const handleExportToExcel = async () => {
        const headers =
          activeReport === 'SFC'
            ? reportHeaders.SFC
            : reportHeaders.SFC_Admin;

        const rows = filteredRows?.length ? filteredRows : [];

        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet('Report');

        // style header row
        const headerRow = sheet.addRow(headers);
        headerRow.height = 25;
        headerRow.eachCell((cell) => {
          cell.font = { bold: true, color: { argb: 'FF000000' } };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ACACAC' },
          };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // data rows and center content
        rows.forEach((row) => {
          const dataRow = sheet.addRow(row);
          dataRow.height = 20;
          dataRow.eachCell((cell) => {
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
          });
        });

        sheet.columns.forEach((col) => (col.width = 30));

        //trigger download with file name
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer]), `${activeReport}_Report.xlsx`);
        });
      };


  const handleFilterChange = (value, idx) => {
    setColumnFilters((prev) => ({ ...prev, [idx]: value }));
  };

  // Handle clearing individual filters
  const handleClearHierarchy = () => {
    if (employeeLevel) return;
    setSelectedHierarchy(null);
  };

  const handleClearDesignation = () => {
    if (employeeLevel) return; 
    setSelectedDesignation(null);
  };

  const handleClearDateRange = () => {
    setDateRange({ from: null, to: null });
  };
const filterBoxRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (event) => {
    const isInsideBox =
      filterBoxRef.current &&
      filterBoxRef.current.contains(event.target);

    const isTextboxDropdown = event.target.closest('.textbox-dropdown');
    const isFilterButton = event.target.closest('.filter-toggle-btn');

    if (isInsideBox || isTextboxDropdown || isFilterButton) {
      return;
    }

    setShowFilters(false);
  };

  if (showFilters) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [showFilters]);

  return (
    <> {isPageLoading ? (
        <div className="flex justify-center items-center h-screen">
          <Loader />
        </div>
      ) : (
    <div className="w-full flex flex-col bg-white lg:pt-16 lg:p-4 smAndMd:-pt-32 min-h-screen  ">
      {/* Top Bar */}
      <div className="flex justify-center items-center w-full h-10 relative p-4 lg:p-2 mt-20 mb-2 lg:mt-0 lg:mb-0 lg:flex lg:justify-start lg:items-center smAndMd:mt-4 smAndMd:mb-4 px-3 py-5">
        <Link to="/home" className="absolute left-4 lg:left-0">
          <img src={leftArrowIcon} alt="leftIcon" height="9" width="9" />
        </Link>
        <p className="text-lg font-semibold text-center lg:ml-4 text-primary">
          Reports
        </p>
      </div>

      <div className="w-full h-[0.5px] bg-line-color"></div>

      {/* Report Switcher */}
      <div className="flex text-sm items-center  mt-2 lg:-mb-2  smAndMd:mt-4 smAndMd:ml-2 lg:flex-row justify-between smAndMd:justify-center">
        <div className="flex items-center">
          <p
            className={`cursor-pointer text-baseMd  font-medium px-4 py-2 transition-all duration-200 ${
              activeReport === 'SFC'
                ? 'text-primary border-b-2 border-primary font-semibold'
                : 'text-gray-500 font-medium hover:text-primary'
            }`}
            onClick={() => setActiveReport('SFC')}
          >
            SFC Report
          </p>

          {area !== undefined &&  ! ['T','A','R'].includes(area) && ( <p
            className={`cursor-pointer text-baseMd font-medium px-4 py-2  transition-all duration-200 ${
              activeReport === 'SFC_Admin'
                ? 'text-primary border-b-2 border-primary font-semibold'
                : 'text-gray-500 font-medium hover:text-primary'
            }`}
            onClick={() => setActiveReport('SFC_Admin')}
          >
            SFC-Admin Report
          </p>)}
        </div>

        <div className="-mt-1 smAndMd:hidden">
          <p
            className="flex items-center text-gray-500 font-medium text-sm text-[14px] mt-2 cursor-pointer filter-toggle-btn"
            onClick={() => setShowFilters(!showFilters)}
          >
            <img
              src={filter}
              alt="filter"
              className="w-[16px] h-[16px] mr-2 text-[#514D4C]"
            />
            <span>Filter</span>
            <span className="ml-2">
              <img
                src={expandfilter}
                alt="expand"
                className={`w-4 h-4 transform transition-transform duration-300 ${
                  showFilters ? 'rotate-180' : ''
                }`}
              />
            </span>
          </p>
        </div>
      </div>

<div className="w-full relative lg:pt-2 -mb-2">
  <div className="lg:hidden sticky top-0 left-0 z-20  px-0 pt-1 pb-0  bg-white">
    <button
      onClick={() => setShowFilters(!showFilters)}
      className="flex items-center gap-1.5   bg-white rounded-md px-2.5 py-1.5  filter-toggle-btn"
    >
      <img src={filter} alt="filter" className="w-[14px] h-[14px]" />
      <span className="text-xs font-medium text-gray-600">Filter</span>
      <img
        src={expandfilter}
        alt="expand"
        className={`w-3 h-3 transform transition-transform duration-300 ${
          showFilters ? 'rotate-180' : ''
        }`}
      />
    </button>
  </div>

  <div className="lg:hidden px-2">
    <div
      className="
        overflow-x-auto overflow-y-hidden flex gap-2 items-center mt-0 lg:-mb-1 
        px-0 lg:px-0
        py-0 pb-2
        [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-widthy:none]
        bg-white
      "
    >
      {selectedHierarchy && (
        <div className="inline-flex items-center gap-1.5 bg-gray-100 border border-gray-300 rounded-md px-2.5 py-1.5 shadow-sm flex-shrink-0 max-w-[70%] lg:max-w-none ">
          <span className="text-xs text-gray-700 whitespace-nowrap overflow-hidden text-ellipsis max-w-[90%] lg:max-w-none">
            <span className="font-semibold text-primary">Hierarchy:</span>{' '}
            {selectedHierarchy.hierarchy}
          </span>
          <button
            onClick={handleClearHierarchy}
            disabled={employeeLevel}
            className={`flex items-center justify-center w-4 h-4 rounded-full bg-gray-300 text-gray-600 text-[10px] font-bold transition-all duration-200 ${
              employeeLevel
                ? 'opacity-50'
                : 'hover:bg-primary/80 hover:text-white hover:scale-110 active:scale-95'
            }`}
          >
            ✕
          </button>
        </div>
      )}

      {selectedDesignation && (
        <div className="inline-flex items-center gap-1.5 bg-gray-100 border border-gray-300 rounded-md px-2.5 py-1.5 shadow-sm flex-shrink-0">
          <span className="text-xs text-gray-700 whitespace-nowrap">
            <span className="font-semibold text-primary">Designation:</span>{' '}
            {selectedDesignation.designation}
          </span>
          <button
            onClick={handleClearDesignation}
            disabled={employeeLevel}
            className={`flex items-center justify-center w-4 h-4 rounded-full bg-gray-300 text-gray-600 text-[10px] font-bold transition-all duration-200 ${
              employeeLevel
                ? 'opacity-50'
                : 'hover:bg-primary/80 hover:text-white hover:scale-110 active:scale-95'
            }`}
          >
            ✕
          </button>
        </div>
      )}

      {dateRange.from && dateRange.to && (
        <div className="inline-flex items-center gap-1.5 bg-gray-100 border border-gray-300 rounded-md px-2.5 py-1.5 shadow-sm flex-shrink-0">
          <span className="text-xs text-gray-700 whitespace-nowrap">
            <span className="font-semibold text-primary">Date:</span>{' '}
            {dateRange.from} to {dateRange.to}
          </span>
          <button
            onClick={handleClearDateRange}
            className="flex items-center justify-center w-4 h-4 rounded-full bg-gray-300 text-gray-600 text-[10px] font-bold transition-all duration-200 hover:bg-primary/80 hover:text-white hover:scale-110 active:scale-95"
          >
            ✕
          </button>
        </div>
      )}
    </div>
  </div>
</div>

      {showFilters && (
          <div className="absolute smAndMd:right-2 right-3 smAndMd:top-44 top-36 z-50">
            <div ref={filterBoxRef}
            onClick={(e) => e.stopPropagation()}
            className="bg-white border border-gray-200 shadow-lg rounded-xl w-[93vw] smAndMd:w-[96vw] sm:w-[450px] p-4"
            >
              <div className="text-[14px] smAndMd:pb-1 gap-3 gap-y-10 smAndMd:my-2">

                <div className='my-2'>
                  <Textbox
                  label={'Hierarchy'}
                  value={selectedHierarchy?.hierarchy || ''}
                  options={hierarchydropdown
                    ?.map((item) => item.hierarchy)
                    .filter((h) => h && h.trim() !=='')}
                  onChange={(val) => {
                    if (employeeLevel === 'T') return;
                    const selectedItem = hierarchydropdown.find((item) => item.hierarchy === val);
                    setSelectedHierarchy(selectedItem);
                  }}
                  disabled={employeeLevel}
                />

                </div>
                <div className='my-2'>
                 <Textbox
                  label={'Designation'}
                  value={selectedDesignation?.designation || ''}
                  options={desigdata?.map((item) => item.designation)}
                  onChange={(val) => {
                    if (employeeLevel === 'T') return;
                    const selectedItem = desigdata?.find((item) => item.designation === val);
                    setSelectedDesignation(selectedItem || null);
                  }}
                  disabled={employeeLevel}
                />

                </div>
                <div className='my-2'>
                  <Daterange
                  label="Date Range"
                  from={dateRange.from}
                  to={dateRange.to}
                  onChange={(from, to) => {
                    setDateRange({ from, to });
                  }}
                />
                  </div>
              </div>

              <div className="flex justify-end mt-6 gap-3">
                  <button
                  className="px-8 py-2.5 text-sm rounded-full border border-primary font-medium text-primary transition-all duration-200 hover:bg-primary/90 hover:text-white"
                  onClick={() => setShowFilters(false)}
                >
                  Close
                </button>
              </div>

            </div>
          </div>
        )}

    { /* Desktop Table View */}
          <div className="hidden lg:block border border-gray-200 rounded-md overflow-x-auto overflow-y-auto max-h-96 mt-4">
            <div
              className="grid"
              style={{
                gridTemplateColumns: `repeat(${headers.length}, 180px)`,
              }}
            >
              {/* Header Row */}
              {headers.map((head, i) => (
                <div
                  key={i}
                  className="z-0 p-4 text-xs font-semibold bg-gray-200 border-b border-gray-300 text-center sticky top-0 "
                  style={{
                    borderRight:
                      i !== headers.length - 1 ? '1px solid #e5e7eb' : 'none',
                  }}
                >
                  {head}
                </div>
              ))}

              {/* Filter Row */}
              {headers.map((_, i) => (
                <div
                  key={i}
                  className="z-0 p-1 border-b border-gray-300 text-center bg-gray-100 sticky top-[49px]"
                  style={{
                    borderRight:
                      i !== headers.length - 1 ? '1px solid #e5e7eb' : 'none',
                  }}
                >
                  <div className="relative w-full">
                    <input
                      type="text"
                      value={columnFilters[i] || ''}
                      onChange={(e) =>
                        setColumnFilters((prev) => ({
                          ...prev,
                          [i]: e.target.value,
                        }))
                      }
                      placeholder="Filter"
                      className="w-full p-2 pl-7 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                    />
                    <img
                      src={filters}
                      alt="filter"
                      className="absolute left-2 top-1/2 transform -translate-y-1/2 w-3 h-3 pointer-events-none"
                    />
                  </div>
                </div>
              ))}

              {/* Rows */}
              {filteredRows?.length > 0 ? (
                filteredRows.map((row, rIdx) =>
                  row.map((cell, cIdx) => {
                    const rightAlignCols =
                      activeReport === 'SFC'
                        ? [9,10,11]
                        : [9,10,11];

                    return (
                      <div
                        key={`${rIdx}-${cIdx}`}
                        className={`p-3 text-xs border-b border-gray-200 ${
                          rightAlignCols.includes(cIdx)
                            ? 'text-right'
                            : 'text-center'
                        }`}
                        style={{
                          borderRight:
                            cIdx !== row.length - 1
                              ? '1px solid #e5e7eb'
                              : 'none',
                        }}
                      >
                        {cell}
                      </div>
                    );
                  })
                )
              ) : (
                <div className="p-4 text-sm text-gray-500 col-span-full">
                  No Data Found
                </div>
              )}
            </div>
          </div>

        {/* Mobile Global Filter */}
          <div className="lg:hidden  flex items-center gap-2  mt-0 top-0 bg-white  p-2 ">
            <div className="relative flex items-center w-full">
              <input
                type="text"
                value={mobileFilter || ''}
                onChange={(e) => setMobileFilter(e.target.value)}
                placeholder="Search"
                className="w-full px-2.5 py-1.5 pl-8 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
              />
              <img
                src={search}
                alt="search"
                className="absolute left-2 w-4 h-4 opacity-70"
              />
            </div>
          </div>

          {/* Mobile Card View */}
          <div className="lg:hidden w-full p-2 pt-0 pb-16">
            {filteredRows?.length > 0 ? (
              activeReport === 'SFC' ? (
                <div className="overflow-x-auto overflow-y-visible rounded-lg shadow-sm bg-white border border-gray-400">
                  <div 
                    className="grid"
                    style={{
                      gridTemplateColumns: `max-content repeat(${filteredRows.length}, max-content)`,
                      width: 'fit-content',
                      minWidth: '100%',
                    }}
                  >
                    {/* Header labels - Fixed horizontally only */}
                    {[
                      'Employee Code',
                      'Employee Name',
                      'Designation',
                      'HQ',
                      'Division',
                      'Category',
                      'From City',
                      'To City',
                      'Effective From Date',
                      'Effective To Date',
                      'Distance',
                      'TA (₹)',
                      'DA (₹)',
                      'Total Amount (₹)',
                    ].map((label, i) => (
                      <div
                        key={`label-${i}`}
                        className="py-2 px-3 text-[13px] font-semibold  text-gray-600 text-left bg-white sticky left-0 z-10 after:content-[''] after:absolute after:top-0 after:right-0 after:h-full after:w-[6px] after:bg-gradient-to-r after:from-transparent after:to-gray-300/30"
                        style={{ 
                          gridColumn: 1, 
                          gridRow: i + 1,
                        }}
                      >
                        {label}
                      </div>
                    ))}

                    {/* Data cells */}
                    {filteredRows.map((row, colIdx) => {
                      const dataMap = [0, 1, 2, 4, 3, 7, 5, 6, 12, 13, 8, 9, 10, 11];
                      return dataMap.map((rowIndex, cellIdx) => (
                        <div
                          key={`${colIdx}-${cellIdx}`}
                          className={`py-2 px-3 text-left text-[13px] text-gray-700 border-b  border-gray-300 whitespace-normal break-words ${
                            colIdx % 2 === 0 ? 'bg-gray-50' : 'bg-white'
                          }`}
                          style={{ 
                            gridColumn: colIdx + 2, 
                            gridRow: cellIdx + 1,
                          }}
                        >
                          {row[rowIndex]}
                        </div>
                      ));
                    })}
                  </div>
                </div>
              ) : (
                // Expense Detail layout 
                <div className="overflow-x-auto overflow-y-visible rounded-lg shadow-sm bg-white border border-gray-400">
                  <div 
                    className="grid"
                    style={{
                      gridTemplateColumns: `max-content repeat(${filteredRows.length}, max-content)`,
                      width: 'fit-content',
                      minWidth: '100%',
                    }}
                  >
                    {/* Header labels - Fixed horizontally only */}
                    {[
                      'Employee Code',
                      'Employee Name',
                      'Designation',
                      'Category',
                      'HQ',
                      'Division',
                      'From City',
                      'To City',
                      'Approved-Distance (Oneway)',
                      'Effective From Date',
                      'Effective To Date',
                      'Transit Allownace (₹)',   
                      'Daily Allownace (₹)',                 
                      'Total Amount (₹)',
                    ].map((label, i) => (
                      <div
                        key={`label-${i}`}
                        className="py-2 px-3   border-gray-300 text-[13px] font-semibold text-gray-600 text-left bg-white sticky left-0 z-10 after:content-[''] after:absolute after:top-0 after:right-0 after:h-full after:w-[6px] after:bg-gradient-to-r after:from-transparent after:to-gray-300/30"
                        style={{ 
                          gridColumn: 1, 
                          gridRow: i + 1,
                        }}
                      >
                        {label}
                      </div>
                    ))}

                    {/* Data cells */}
                    {filteredRows.map((row, colIdx) => {
                      const dataMap = [0, 1, 2, ,7 ,4, 3, 5, 6, 9, 13, 14, 12, 11, 11];
                      return dataMap.map((rowIndex, cellIdx) => (
                        <div
                          key={`${colIdx}-${cellIdx}`}
                          className={`py-2 px-3 text-left text-[13px] text-gray-700 border-b  border-gray-300 whitespace-normal break-words ${
                            colIdx % 2 === 0 ? 'bg-gray-50' : 'bg-white'
                          }`}
                          style={{ 
                            gridColumn: colIdx + 2, 
                            gridRow: cellIdx + 1,
                          }}
                        >
                          {row[rowIndex]}
                        </div>
                      ));
                    })}
                  </div>
                </div>
              )
            ) : (
              <div className="text-primary flex justify-center items-center font-medium h-1/2 mt-56">
                No Data Found
              </div>
            )}
          </div>
          {filteredRows.length > 0 && (
            <div className="flex justify-end mt-4 px-2 pr-0 smAndMd:justify-center smAndMd:fixed smAndMd:bottom-0 smAndMd:left-0 smAndMd:right-0 smAndMd:bg-white smAndMd:z-10 smAndMd:shadow-md ">
              <button
                onClick={handleExportToExcel}
                className="bg-primary text-white rounded-full mx-2 mr-0 my-2 px-6 py-3 text-sm font-medium smAndMd:w-full smAndMd:rounded-3xl smAndMd:text-lg"
              >
                Export to Excel
              </button>
            </div>
          )}
        </div>
      )}
      </>
  );
};

export default Sfcreport;
